<template>
    <footer class="footer has-cards">
        <!-- <div class="container container-lg">
            <div class="row">
                <div class="col-md-6 mb-5 mb-md-0">
                    <div class="card card-lift--hover shadow border-0">
                        <router-link to="/landing" title="Landing Page">
                            <img v-lazy="'img/theme/landing.jpg'" class="card-img">
                        </router-link>
                    </div>
                </div>
                <div class="col-md-6 mb-5 mb-lg-0">
                    <div class="card card-lift--hover shadow border-0">
                        <router-link to="/profile" title="Profile Page">
                            <img v-lazy="'img/theme/profile.jpg'" class="card-img">
                        </router-link>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="container">
            <div class="row row-grid align-items-center my-md">
                <div class="col-lg-6">
                    <h3 class="text-primary font-weight-light mb-2">Thank you for supporting us!</h3>
                    <!-- <h4 class="mb-0 font-weight-light">Let's get in touch on any of these platforms.</h4> -->
                </div>
            </div>
            <hr>
            <div class="row align-items-center justify-content-center"> <!-- 修改为 justify-content-center -->
                <div class="col-md-12 text-center"> <!-- 添加 text-center -->
                    <!-- 用户协议和隐私政策 -->
                    <div class="mb-2">
                        <ul class="nav nav-footer justify-content-center">
                            <li class="nav-item">
                                <a href="/protocol" class="nav-link" target="_blank">《用户协议》</a>
                            </li>
                            <li class="nav-item">
                                <a href="/privacy" class="nav-link" target="_blank">《隐私政策》</a>
                            </li>
                        </ul>
                    </div>
                    
                    <!-- Copyright -->
                    <div class="mb-2">
                        Copyright &copy; {{year}} 湖南心悦山水户外用品有限公司
                    </div>
                    
                    <!-- 备案号 -->
                    <div>
                        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">湘ICP备2025099763号</a> 
                        <p>客服邮箱：<a href="mailto:xyssltd@163.com" target="_blank" rel="noopener">xyssltd@163.com</a></p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>

/* 自定义间距和样式 */
.nav-footer {
    list-style: none;
    padding-left: 0;
}

.nav-footer .nav-item {
    display: inline-block;
    margin: 0 10px; /* 调整链接间距 */
}

.nav-footer .nav-link {
    color: inherit;
    text-decoration: none;
}

.nav-footer .nav-link:hover {
    text-decoration: underline;
}
</style>
